import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import BuyPlan from "./PlanPurchase/BuyPlan";
import { useEffect } from "react";



const LandingPage2 = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const [planCode, setPlanCode] = useState("");
    const [tenantId, setTenantId] = useState("T539001XT0B");


    useEffect(() => {
        /* ---------- LOAD CSS ---------- */
        const cssFiles = [
            "/landing/css/font-awesome-all.css",
            "/landing/css/flaticon.css",
            "/landing/css/owl.css",
            "/landing/css/bootstrap.css",
            "/landing/css/jquery.fancybox.min.css",
            "/landing/css/animate.css",
            "/landing/css/nice-select.css",
            "/landing/css/elpath.css",
            "/landing/css/color.css",
            "/landing/css/style.css",
            "/landing/css/module-css/banner.css",
            "/landing/css/module-css/feature.css",
            "/landing/css/module-css/service.css",
            "/landing/css/module-css/about.css",
            "/landing/css/module-css/benefits.css",
            "/landing/css/module-css/estimate.css",
            "/landing/css/module-css/chooseus.css",
            "/landing/css/module-css/testimonial.css",
            "/landing/css/module-css/faq.css",
            "/landing/css/module-css/awards.css",
            "/landing/css/module-css/responsive.css",
        ];

        const loadedLinks = cssFiles.map((href) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
            return link;
        });

        /* ---------- LOAD JS ---------- */
        const jsFiles = [
            "/landing/js/jquery.js",
            "/landing/js/bootstrap.min.js",
            "/landing/js/owl.js",
            "/landing/js/wow.js",
            "/landing/js/jquery.fancybox.js",
            "/landing/js/appear.js",
            "/landing/js/isotope.js",
            "/landing/js/jquery.nice-select.min.js",
            "/landing/js/nav-tool.js",
            "/landing/js/tilt.jquery.js",
            "/landing/js/script.js",
            "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css",
        ];

        const loadedScripts = jsFiles.map((src) => {
            const script = document.createElement("script");
            script.src = src;
            script.defer = true;
            document.body.appendChild(script);
            return script;
        });

        /* ---------- CLEANUP ---------- */
        return () => {
            loadedLinks.forEach((link) => document.head.removeChild(link));
            loadedScripts.forEach((script) =>
                document.body.removeChild(script)
            );
        };
    }, []);

    return (
        <div className="overflow-x-hidden">
            <div className="min-h-screen text-slate-900">

                {/* HERO SECTION */}
                <div
                    className="text-white relative mb-[-60px] z-0"
                    style={{
                        height: "600px",
                        backgroundImage: "url(/assets/img/hero-bg.png)",
                        backgroundSize: "contain",
                        backgroundPosition: "right bottom",
                        backgroundRepeat: "no-repeat",
                        backgroundColor: "#DEE0DF",
                    }}
                >
                    <div className="max-w-7xl mx-auto px-4 lg:px-8 h-full">
                        <div className="grid gap-8 items-stretch h-full">
                            <div className="space-y-6 text-left flex flex-col justify-center relative z-10">
                                <div className='flex justify-between items-center w-full'>
                                    <a href='/'>
                                        <img src="http://swasthopd.com/assets/img/logo/swastha-opd-logo-1.png" alt='' className='w-[180px]' />
                                    </a>
                                    <a href='/'>
                                        <img src="assets/img/combined-logo.png" alt='' className='w-[180px]' />
                                    </a>
                                </div>
                                <h1 className="font-semibold !leading-[60px] pt-[40px] pb-[0px] text-3xl sm:text-4xl lg:text-5xl max-md:!leading-[50px] mainfont">
                                    Comprehensive Family
                                    <br />
                                    Healthcare.
                                    <br />
                                    Simple, Affordable,
                                    <br />
                                    Trusted.
                                </h1>

                                <div className="flex flex-wrap gap-4 pt-2">
                                    <a href="#pricing" className="px-8 py-3 rounded-full bg-white !text-[#104A52] text-sm sm:text-base font-semibold shadow-md hover:bg-slate-100 transition">
                                        View Plans
                                    </a>
                                </div>
                                <div className='w-full h-[60px]'></div>
                            </div>
                        </div>
                    </div>
                </div>





                {/* Hero Feature Cards */}
                <div className="relative z-20 max-w-6xl mx-auto px-4 lg:px-8 pb-8 lg:pb-12">
                    <div className="grid lg:grid-cols-4 grid-cols-2 items-center gap-3 sm:gap-4">
                        {[
                            "Family of 4",
                            "24/7 Doctor",
                            "Medicine Discounts",
                            "Diagnostic Savings",
                        ].map((label, i) => (
                            <div
                                key={label}
                                className="bg-white rounded-2xl shadow-md flex items-center max-md:block gap-2.5 sm:gap-3 !py-[30px] sm:py-3.5 px-2.5 sm:px-4 relative z-20"
                            >
                                <div className="w-[60px] h-[60px] rounded-xl bg-[#f7f8fc] flex items-center justify-center text-lg sm:text-xl shrink-0">
                                    {i === 0 && <i className="fa-solid fa-users text-[30px]"></i>}
                                    {i === 1 && <i class="fa-solid fa-briefcase-medical text-[30px]"></i>}
                                    {i === 2 && <i class="fa-solid fa-pills text-[30px]"></i>}
                                    {i === 3 && <i class="fa-solid fa-microscope text-[30px]"></i>}
                                </div>
                                <p className="!text-[20px] mb-0 sm:text-sm font-semibold text-slate-800 max-md:mt-3 mainfont">
                                    {label}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* PRICING / PLANS */}
                <section className="pt-[40px] pb-[100px] bg-[#ffffff] max-md:px-[15px]" id="pricing">
                    <div className="row mb-5">
                        <div className="col-md-6 text-center mx-auto">
                            <span
                                className="subtitle text-uppercase mb-3 text-[14px]"
                                data-aos="fade-up"
                                data-aos-delay={0}
                            >
                                Pricing
                            </span>
                            <h2 className="text-[32px] mb-3 mainfont" data-aos="fade-up" data-aos-delay={100}>
                                Plans Available For You
                            </h2>
                            <p className="mainfont" data-aos="fade-up" data-aos-delay={200}>
                                Affordable plans designed to fit your family.
                            </p>
                        </div>
                    </div>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-lg-12 mt-4">
                                <div className="pricing-style-one shadow-none wow fadeInUp !border-[0px] !bg-[#f7f7f7] rounded-[36px]">
                                    <div className='flex justify-between md:items-center md:mb-[16px] max-md:flex-col max-md:gap-[24px] max-md:mb-[48px] max-md:items-stretch'>
                                        <div className="pricing-header !my-0 !border-[0px]">
                                            <h4 className='mainfont'>LifeCare Plan </h4>
                                            <p className='mainfont'>Swasth Life Checkb4buy Plus Plan (4 Members)</p>
                                            <h2 className='mainfont'>₹5,250</h2>
                                            <span className='mainfont'>including GST</span>
                                        </div>
                                        <div
                                            onClick={() => {
                                                setPlanCode("SwasthLifepluscheck");
                                                setOpenPopup(true);
                                            }}
                                            className="btn btn-md circle btn-gradient animation mt-0 customButton text-white"
                                        >
                                            Buy Now
                                        </div>
                                    </div>
                                    <ul className="flex items-start gap-[60px] max-md:flex-col max-md:gap-[8px]">
                                        <div className="flex flex-col gap-[8px]">
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>Unlimited</strong> Tele Doctor Consultation
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>1 Credit</strong> In-person General Physician
                                                    Consultation
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>1 Credit</strong> At home dental scan
                                                </div>
                                            </li>
                                        </div>
                                        <div className="flex flex-col gap-[8px]">
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>2 Credit</strong> Virtual Diabetic Consultation
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>Upto 50% Off</strong> Diagnostic & Radiology
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>Upto 20% Off</strong> Prescribed Pharmacy
                                                </div>
                                            </li>
                                        </div>
                                    </ul>

                                </div>
                            </div>
                            <div className="col-lg-12 mt-4">
                                <div className="pricing-style-one shadow-none wow fadeInUp !border-[0px] !bg-[#f7f7f7] rounded-[36px]">
                                    <div className='flex justify-between md:items-center md:mb-[16px] max-md:flex-col max-md:gap-[24px] max-md:mb-[48px] max-md:items-stretch'>
                                        <div className="pricing-header !my-0 !border-[0px]">
                                            <h4 className='mainfont'>Basic Plan</h4>
                                            <p className='mainfont'>Treat Sure Checkb4buy plan (4 Members)</p>
                                            <h2 className='mainfont'>₹10,499</h2>
                                            <span className='mainfont'>Including GST</span>
                                        </div>
                                        <div
                                            onClick={() => {
                                                setPlanCode("TreatSureCheck");
                                                setOpenPopup(true);
                                            }}
                                            className="btn btn-md circle btn-gradient animation mt-0 customButton text-white"
                                        >
                                            Buy Now
                                        </div>
                                    </div>
                                    <ul className="flex items-start gap-[60px] max-md:flex-col max-md:gap-[8px]">
                                        <div className="flex flex-col gap-[8px]">
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>Unlimited</strong> Tele Doctor Consultation
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>2 Credit</strong> In-person General Physician
                                                    Consultation
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>₹500</strong> Pharmacy Wallet - Prescribed
                                                    Medicines
                                                </div>
                                            </li>
                                        </div>
                                        <div className="flex flex-col gap-[8px]">
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>1 Credit</strong> At Home Dental Scan
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>1 Credit</strong> Vitual Diabetic Consultation
                                                </div>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-12 mt-4">
                                <div className="pricing-style-one shadow-none wow fadeInUp !border-[0px] !bg-[#f7f7f7] rounded-[36px]">
                                    <div className='flex justify-between md:items-center md:mb-[16px] max-md:flex-col max-md:gap-[24px] max-md:mb-[48px] max-md:items-stretch'>
                                        <div className="pricing-header !my-0 !border-[0px]">
                                            <h4 className='mainfont'>Basic Plus Plan</h4>
                                            <p className='mainfont'>Sehat Sahyogi Checkb4buy plan (4 Members)</p>
                                            <h2 className='mainfont'>₹12,599</h2>
                                            <span className='mainfont'>Including GST</span>
                                        </div>
                                        <div
                                            onClick={() => {
                                                setPlanCode("SehatSahyogicheck");
                                                setOpenPopup(true);
                                            }}
                                            className="btn btn-md circle btn-gradient animation mt-0 customButton text-white"
                                        >
                                            Buy Now
                                        </div>
                                    </div>
                                    <ul className="flex items-start gap-[60px] max-md:flex-col max-md:gap-[8px]">
                                        <div className="flex flex-col gap-[8px]">
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>Unlimited</strong> Tele Doctor Consultation
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>4 Credit</strong> In-person General Physician
                                                    Consultation
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>₹1,000</strong> Pharmacy Wallet - Prescribed
                                                    Medicines
                                                </div>
                                            </li>
                                        </div>
                                        <div className="flex flex-col gap-[8px]">
                                            {/* <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>1 Credit</strong> At Home Dental Scan
                                                </div>
                                            </li> */}
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>2 Credit</strong> Vitual Diabetic Consultation
                                                </div>
                                            </li>
                                            <li className='!mb-0'>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="w-[24px] text-green-500 mt-1"
                                                >
                                                    <path d="M20 6L9 17L4 12" />
                                                </svg>
                                                <div>
                                                    <strong>1 Credit</strong> Mental Wellness
                                                </div>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/* TESTIMONIALS */}
                <section className="py-10 lg:py-14 !bg-[#f1fff1]">
                    <div className="max-w-6xl mx-auto px-4 lg:px-8">
                        <div className="row mb-5">
                            <div className="col-md-6 text-center mx-auto">
                                <span
                                    className="subtitle text-uppercase mb-3 text-[14px]"
                                    data-aos="fade-up"
                                    data-aos-delay={0}
                                >
                                    Testimonials
                                </span>
                                <h2 className="text-[32px] mainfont mb-3" data-aos="fade-up" data-aos-delay={100}>
                                    Voices of Our Happy Members
                                </h2>
                                <p className="mainfont" data-aos="fade-up" data-aos-delay={200}>
                                    Real stories from families who trust us for <br />their everyday healthcare needs.
                                </p>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                            {[
                                { name: "Karan Singh", location: "Chandigarh", img: <img src="assets/img/karan.png" alt="not found" />, text: "I’m impressed by their dedication to making healthcare affordable. Their OPD plans fit perfectly within my budget, without compromising quality." },
                                { name: "Sneha Gupta", location: "Jaipur", img: <img src="assets/img/sneha.png" alt="not found" />, text: "Their OPD coverage is a lifesaver. I’ve saved so much on regular doctor visits and diagnostic tests. Thank you for this amazing service!" },
                                { name: "Vikram Mehta", location: "Bangalore", img: <img src="assets/img/vikram.png" alt="not found" />, text: "I travel a lot for work, and Swasth OPD plans have given me peace of mind no matter where I am. Truly reliable and convenient." },
                                { name: "Pooja Verma", location: "Delhi", img: <img src="assets/img/pooja.png" alt="not found" />, text: "From consultations to diagnostics, everything is hassle-free. It’s so convenient, especially when you have kids at home." },
                            ].map((user) => (
                                <div
                                    key={user.name}
                                    className="bg-white rounded-2xl border border-[#cfe9ee] shadow-md p-4 sm:p-5"
                                >
                                    <div className="flex items-center justify-between mb-3 gap-3 max-md:block">
                                        <div className="flex items-center gap-3">
                                            <div className="w-[60px] sm:h-[60px] rounded-full overflow-hidden flex items-center justify-center shrink-0">
                                                {user.img}
                                            </div>
                                            <div>
                                                <p className="text-[20px] mb-0 font-semibold text-[#0f172A] mainfont">
                                                    {user.name}
                                                </p>
                                                <p className="text-[14px] font-medium text-[#0f172A] mainfont">
                                                    {user.location}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-center text-[30px] text-yellow-400">
                                            {"★★★★★".split("").map((s, i) => (
                                                <span key={i}>{s}</span>
                                            ))}
                                        </div>
                                    </div>
                                    <p className="text-[18px] text-slate-600 leading-relaxed mainfont">
                                        {user.text}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* FOOTER */}
                <footer className="bg-gray overflow-hidden">
                    <div className="container">
                        <div className="f-items" style={{ padding: "80px 0" }}>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 footer-item pr-30 pr-md-15 pr-xs-15">
                                    <div className="f-item address">
                                        <a className="navbar-brand" href="/">
                                            <img
                                                src="/assets/img/logo/swastha-opd-logo-1.png"
                                                className="logo"
                                                alt="Logo"
                                                style={{ height: 80 }}
                                            />
                                        </a>
                                        <p className="w-400px mainfont">
                                            At Swasth OPD, we are committed to revolutionizing healthcare by bridging the gap between wellness and accessibility. As a leading health and wellness broker, we specialize in offering tailor-made health plans that cater to businesses and individuals alike. —{" "}
                                            <strong style={{ color: "#000000" }}>
                                                you gain a trusted partner
                                            </strong>
                                        </p>
                                        <ul className="contact-address">
                                            <li>
                                                <p className="mainfont">Our Location</p>
                                                <h4 className="w-400px mainfont">
                                                    642/1 Plot 30, Najafgarh Road Ind Area, West
                                                    Delhi-110015
                                                </h4>
                                            </li>
                                            <li>
                                                <p className="mainfont">Contact Number</p>
                                                <h4 className="w-400px mainfont">
                                                    1800 309 2740
                                                </h4>
                                            </li>
                                            <li>
                                                <p className="mainfont">Support Email</p>
                                                <h4 className="w-400px mainfont">
                                                    hello@swasthopd.com
                                                </h4>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-item">
                                    <div className="f-item link">
                                        <h4 className="widget-title mainfont">Quick Links</h4>
                                        <ul className="pl-0">
                                            <li>
                                                <Link to="/" className="no-underline mainfont">
                                                    Home
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/plans"
                                                    className="no-underline mainfont"
                                                >
                                                    Plans
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/contact" className="no-underline mainfont">
                                                    Contact
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-item">
                                    <div className="f-item link">
                                        <h4 className="widget-title mainfont">Our Services</h4>
                                        <ul className="pl-0">
                                            <li>
                                                <Link to="/term-of-use" className="no-underline mainfont">
                                                    Terms Of Use
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/privacy-policy" className="no-underline mainfont">
                                                    Privacy Policy
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/cancellation-policy" className="no-underline mainfont">
                                                    Cancellation Policy
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/shipping-delivery-policy"
                                                    className="no-underline mainfont"
                                                >
                                                    Shipping and Delivery Policy
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Start Footer Bottom */}
                    <div className="footer-bottom bg-[#1F2B38] text-light">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <p className="mainfont">
                                        © Copyright {new Date().getFullYear()}. All Rights Reserved by{" "}
                                        <a href="#top">Swasth OPD</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Footer Bottom */}
                </footer>

                <BuyPlan
                    planCode={planCode}
                    tenantId={tenantId}
                    showPopUp={openPopup}
                    setShowPopUp={setOpenPopup}
                />
            </div>
        </div>
    )
}

export default LandingPage2